import { useState, useRef, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Password } from "primereact/password";
import LoginService from "../../service/LoginService";
import { Link, useHistory, useLocation } from "react-router-dom";
import localeText from "../../locale";
import SEO from "../../components/SEO/SEO";
import "./Login.css";

const ResetPassword = () => {
  const location = useLocation();
  const history = useHistory();
  const toast = useRef(null);
  const loginService = new LoginService();

  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    const tokenParam = params.get("token");

    if (!emailParam || !tokenParam) {
      toast.current?.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("invalidLink"),
        life: 6000,
      });
      setTimeout(() => {
        history.push("/login");
      }, 3000);
      return;
    }

    setEmail(emailParam);
    setToken(tokenParam);
  }, [location, history]);

  async function handleResetPassword() {
    if (!password || !confirmPassword) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("pleaseFillOut"),
        life: 6000,
      });
      return;
    }

    if (password !== confirmPassword) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("passwordsDoNotMatch"),
        life: 6000,
      });
      return;
    }

    if (password.length < 8) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("passwordTooShort"),
        life: 6000,
      });
      return;
    }

    try {
      setLoading(true);

      const res = await loginService.postConfirmPasswordChange(email, token, password);

      if (res.messageCode === 200001) {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("passwordChangedSuccessfully"),
          life: 6000,
        });

        setTimeout(() => {
          history.push("/login");
        }, 2000);
      } else if (res.messageCode === 500231) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("passwordAlreadyChanged"),
          life: 6000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("errorChangingPassword"),
          life: 6000,
        });
      }

      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("errorChangingPassword"),
        life: 6000,
      });
      console.log(e);
    }
  }

  return (
    <div className="flex">
      <div className="login-container flex flex-column justify-content-between col">
        <SEO
          title="Redefinir Senha - Extraconomy"
          description="Redefina sua senha no Extraconomy."
        />
        <Toast position="top-left" ref={toast} />

        <Link
          to={`${JSON.parse(localStorage.getItem("__extraconomy_ismobile__")) ? "/shop" : "/"}`}
          className="md:align-self-start align-self-center"
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/layout/images/logo-color.png`}
            alt="babylon-layout"
            style={{ height: "40px" }}
          />
        </Link>

        <div className="flex flex-column align-items-center width-100 gap-5">
          <div className="flex flex-column align-items-center gap-2">
            <div className="title text-4xl font-bold" style={{ color: "#181D27" }}>
              {localeText("resetPassword")}
            </div>
            <div className="text-center" style={{ color: "#535862" }}>
              {localeText("enterNewPassword")}
            </div>
          </div>

          <div className="flex flex-column gap-4 w-full" style={{ maxWidth: "360px" }}>
            <div className="w-full">
              <label className="font-semibold text-base" htmlFor="email">
                Email
              </label>
              <div className="login-input-wrapper mt-2">
                <InputText
                  value={email}
                  name="email"
                  className="w-full p-3"
                  disabled
                  style={{ backgroundColor: "#f5f5f5" }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="font-semibold text-base" htmlFor="password">
                {localeText("newPassword")}
              </label>
              <div className="login-input-wrapper mt-2">
                <Password
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  className="w-full"
                  inputClassName="w-full p-3"
                  placeholder={localeText("enterNewPassword")}
                  toggleMask
                  feedback={false}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="font-semibold text-base" htmlFor="confirmPassword">
                {localeText("confirmPassword")}
              </label>
              <div className="login-input-wrapper mt-2">
                <Password
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  name="confirmPassword"
                  className="w-full"
                  inputClassName="w-full p-3"
                  placeholder={localeText("confirmNewPassword")}
                  toggleMask
                  feedback={false}
                />
              </div>
            </div>

            <div>
              <Button
                label={localeText("changePassword")}
                loading={loading}
                onClick={handleResetPassword}
                style={{ backgroundColor: "#28AB69" }}
                className="w-full font-semibold text-base text-white p-no-outline border-none px-4 py-3 border-round-lg"
              />
            </div>

            <div className="text-center">
              <Link to="/login" style={{ color: "#245AE5" }}>
                {localeText("backToLogin")}
              </Link>
            </div>
          </div>
        </div>

        <div>
          <p>© Extraconomy 2025</p>
        </div>
      </div>

      <div className="col p-0 secondary-login-container md:flex hidden">
        <div className="text-white w-full align-self-end secondary-login-container-text flex flex-column gap-5">
          <div>
            <img src={require("../images/pages/stars.png")} alt="stars" />
          </div>
          <div className="title font-bold" style={{ fontSize: "3.5rem", lineHeight: "1.2" }}>
            {localeText("resetYourPassword")}
          </div>
          <div className="text-lg" style={{ lineHeight: "1.5" }}>
            {localeText("createNewPasswordDescription")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
